<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1>
          Dairy Post-Spring Consult {{ getDairySeasonStartYear }}
          <span v-if="currentClientName">- {{ currentClientName }}</span>
        </h1>
      </div>
    </div>

    <loader v-if="isLoadingApi"></loader>

    <template v-if="dataFetched">
      <consult-opened-by-other-warning></consult-opened-by-other-warning>
      <consult-backend-errors store-namespace="currentConsult"></consult-backend-errors>

      <consult-navigation></consult-navigation>

      <div class="row">
        <div :class="[showVetNotes ? 'col-xs-9' : 'col-xs-12']">
          <vet-notes-toggle style="position: absolute; top: 30px; right: 20px"> </vet-notes-toggle>
          <component :is="currentComponent" :key="currentComponent"> </component>
        </div>

        <vet-notes
          field-name="vet_notes"
          model-name="ClientDetails"
          email-notification="sc-vet-notes"
          v-show="showVetNotes"
        >
        </vet-notes>
      </div>

      <consult-navigation v-on:step-changed="scroll()"></consult-navigation>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { springConsultComponents } from '../../components/spring_consult'

import currentConsult from '@/_store/current_consult.module'
import springConsult from '@/_store/spring_consult.module'

import ConsultBackendErrors from '@/components/ConsultBackendErrors'
import ConsultOpenedByOtherWarning from '@/components/ConsultOpenedByOtherWarning'
import ConsultNavigation from '@/components/ConsultNavigation'
import VetNotes from '@/components/VetNotes'
import VetNotesToggle from '@/components/VetNotesToggle'
import { scrollToTop } from '@/_helpers'

export default {
  name: 'SpringConsultPage',
  components: {
    ...springConsultComponents,
    ConsultBackendErrors,
    ConsultNavigation,
    ConsultOpenedByOtherWarning,
    VetNotes,
    VetNotesToggle,
  },
  data() {
    return {
      isLoadingApi: false,
      dataFetched: false,
    }
  },
  created() {
    Object.assign(currentConsult.state, springConsult.stateMixin)
    Object.assign(currentConsult.actions, springConsult.actionsMixin)
    Object.assign(currentConsult.mutations, springConsult.mutationsMixin)
    Object.assign(currentConsult.getters, springConsult.gettersMixin)

    if (this.$store.hasModule('currentConsult')) {
      this.$store.unregisterModule('currentConsult')
    }

    this.$store.registerModule('currentConsult', currentConsult)
    this.setClient(this.$route.params.client_id)
    this.setCurrentConsultType('springConsult')
  },
  beforeDestroy() {
    this.backupState()
  },
  mounted() {
    this.setClient(this.$route.params.client_id)
    let readOnly = Boolean(this.$route.params.history)
    this.fetchData(readOnly)
  },
  methods: {
    ...mapMutations('currentConsult', {
      setCurrentConsultType: 'setConsultType',
    }),
    ...mapActions('currentConsult', ['backupState', 'getConsultData', 'getReadOnlyData', 'setClient', 'setFieldValue']),
    scroll: function () {
      scrollToTop()
    },
    fetchData(readOnly) {
      this.isLoadingApi = true

      let consultParams = {
        clientId: this.$route.params.client_id,
        season: this.$route.params.season,
      }

      let action = readOnly ? this.getReadOnlyData : this.getConsultData

      return action(consultParams)
        .then(() => {
          this.dataFetched = true
        })
        .catch(() => {
          this.$store.dispatch('alert/error', {
            message: 'An error occurred. Contact the administrator.',
            persist: true,
          })
          this.$router.push('/')
        })
        .finally(() => {
          this.isLoadingApi = false
        })
    },
  },
  computed: {
    ...mapGetters('currentConsult', [
      'currentComponent',
      'currentClientName',
      'animals',
      'getFieldValue',
      'getFieldComment',
      'enabledAnimals',
      'showVetNotes',
    ]),
    getDairySeasonStartYear: function () {
      return this.$route.params.season
    },
  },
}
</script>

<style>
.farm-fields-xl {
  width: 500px;
}

div.step-section {
  margin: 50px 5px;
}

.step-name {
  color: #337ab7;
  text-decoration: underline;
}

div.comments {
  margin: 20px;
}
</style>
